import { createApp } from 'vue';
import DebugWindow from './index.vue';
import createEl from '@/utils/createEl';

function createDebugWindow() {
    const debugWindow = createApp(DebugWindow, {
        config: JSON.stringify(window.gmf_config),
      });

    const el = createEl('div', 'gmf-debug-window', document.body);
    debugWindow.mount(el);
}

if (window.gmf_config.openDebugWindow) {
    createDebugWindow();
}

document.addEventListener('gmfOpenDebugWindow', () => {
    createDebugWindow();
});